module.exports = __webpack_public_path__ + "static/media/waiting-orange.7265db68.svg";